import React from 'react';

import { SectionHeader } from '../SectionHeader/SectionHeader';
import Tabs from '@src/stories/elements/Tabs/Tabs';
import Tab from '@src/stories/elements/Tabs/Tab';
import Paragraph from '@arctheme-components/elements/Paragraph/Paragraph';
import helpers from 'frontend/js/helpers';

export const SectionTabs = ({ tabs, settings }) => {
  const {
    tabs_padding_top_desktop,
    tabs_padding_bottom_desktop,
    tabs_padding_left_right_desktop,
    tabs_padding_top_mobile,
    tabs_padding_bottom_mobile,
    tabs_padding_left_right_mobile,
    border_width,
    border_color,
    border_color_mobile,
    border_radius,
    body_type_labels,
    body_type_tab
  } = settings.section;

  return (
    <div className='section-tabs'>
      <SectionHeader settings={settings} />

      <div
        className={`section-tabs__tabs pt-[${tabs_padding_top_mobile}px] lg:pt-[${tabs_padding_top_desktop}px] pb-[${tabs_padding_bottom_mobile}px] lg:pb-[${tabs_padding_bottom_desktop}px] px-[${tabs_padding_left_right_mobile}px] lg:px-[${tabs_padding_left_right_desktop}px] rounded-[${border_radius}px]`}
        style={
          {
            '--border-color': border_color || 'transparent',
            '--border-width': !helpers.isTransparent(border_color)
              ? `${border_width}px`
              : '0px',
            '--border-color-mobile': border_color_mobile || 'transparent',
            '--border-width-mobile': !helpers.isTransparent(border_color_mobile)
              ? `${border_width}px`
              : '0px'
          } as React.CSSProperties
        }
      >
        <Tabs settings={settings}>
          {tabs.map((tab) => {
            const {
              padding_top_desktop,
              padding_top_mobile,
              padding_bottom_desktop,
              padding_bottom_mobile,
              padding_left_right_desktop,
              padding_left_right_mobile,
              icon,
              labels: labelsSetting
            } = tab.settings;
            const { labels_color_schema } = tab.color_schemas;

            const labels = labelsSetting.split('|');

            return (
              <Tab
                key={tab.settings.title}
                title={tab.settings.title}
                icon={icon}
              >
                <div
                  className={`pt-[${padding_top_mobile}px] lg:pt-[${padding_top_desktop}px] pb-[${padding_bottom_mobile}px] lg:pb-[${padding_bottom_desktop}px] px-[${padding_left_right_mobile}px] lg:px-[${padding_left_right_desktop}px]`}
                >
                  {labels.length > 0 && (
                    <div className='mb-2.5 flex flex-wrap items-center gap-3'>
                      {labels.map((label) => (
                        <span
                          key={label}
                          className={`color-${labels_color_schema} ${body_type_labels} px-2 rounded-xl`}
                        >
                          {label}
                        </span>
                      ))}
                    </div>
                  )}
                  <Paragraph
                    text={tab.settings.content}
                    maxChars={10000}
                    type={body_type_tab}
                    classes='m-0 rte max-w-[unset]'
                  />
                </div>
              </Tab>
            );
          })}
        </Tabs>
      </div>
    </div>
  );
};
